<div
  class="input"
  [class.input--open]="isCalendarVisible"
  [class.input--error]="hasFormatError || hasError || hasMinMaxError"
  [class.input--disabled]="isDisabled"
>
  <input
    tabindex="0"
    class="input__text"
    [(ngModel)]="dateVisual"
    (ngModelChange)="dateVisualChange($event)"
    (keydown)="keydownChange($event)"
    (click)="toggleCalendar()"
    (paste)="paste($event)"
    [disabled]="isDisabled"
    (blur)="blurChange.emit(true)"
    #input
    [id]="inputID"
    placeholder="dd/mm/aaaa"
  />
  <div class="input__button" tabindex="-1" (click)="toggleCalendar()" matRipple>
    <qr-icon
      tabindex="-1"
      class="input__icon"
      [name]="ICON_CALENDAR"
      [color]="iconColor"
    ></qr-icon>
  </div>
</div>

<p
  class="hint"
  *ngIf="config.hint && !hasFormatError && !hasError && !hasMinMaxError"
  tabindex="-1"
>
  {{ config.hint }}
</p>
<p class="error" *ngIf="hasFormatError" tabindex="-1">
  Utilice el formato: {{ getCurrentDateVisual() }}
</p>
<p class="error" *ngIf="!hasFormatError && hasMinMaxError" tabindex="-1">
  Ingrese una fecha que esté dentro del rango permitido
</p>
<p
  class="error"
  *ngIf="hasError && !hasFormatError && !hasMinMaxError"
  tabindex="-1"
>
  {{ config.errorMsg }}
</p>

<mat-card
  class="calendar"
  [class.calendar--is-visible]="isCalendarVisible"
  [style.width.px]="config.calendarWidth"
  [style.top.px]="positionTop"
  [id]="'calendar-' + inputID"
>
  <mat-calendar
    *ngIf="isCalendarVisible"
    #calendar
    [(selected)]="dateCalendar"
    (selectedChange)="dateCalendarChange($event)"
    [minDate]="minDate"
    [maxDate]="maxDate"
  ></mat-calendar>
</mat-card>
<div
  class="overlay"
  *ngIf="isCalendarVisible"
  (click)="toggleCalendar()"
  tabindex="-1"
></div>
